import { formatWorkspaceMoney, titleCaseLabel } from "../../utils/workspacePresentation";

function occupancyLabel(value) {
  if (value === "staff_technician") return "Operate under host salon";
  if (value === "independent_owner") return "Operate independently";
  if (value === "renter_guest") return "Legacy marketplace guest (deprecated)";
  return titleCaseLabel(value, "Not set");
}

function clientOwnershipLabel(value) {
  if (value === "salon_owned") return "Salon-owned clients";
  if (value === "independent_owned") return "Independent-owned clients";
  return titleCaseLabel(value, "Not set");
}

export default function RenterAcceptanceSummaryCard({
  workspaceName,
  workspaceType,
  occupancyMode,
  clientOwnershipMode,
  agreementVersion,
  depositAmount = null,
  dueNowAmount = null,
  dueLaterAmount = null,
  currency = "cad",
  warningCount = 0,
  acceptedAt = "",
  rentalId = null,
}) {
  return (
    <article className="rounded-[2rem] border border-slate-200 bg-white p-6 shadow-sm">
      <p className="text-xs font-semibold uppercase tracking-[0.22em] text-rose-500">
        Your Workspace Arrangement
      </p>
      <div className="mt-4 space-y-3 text-sm text-slate-600">
        <div>
          <p className="text-xl font-semibold text-slate-950">
            {workspaceName || "Selected workspace"}
          </p>
          <p className="mt-1">{titleCaseLabel(workspaceType, "Workspace")}</p>
        </div>
        <div className="grid gap-3 border-t border-slate-200 pt-3 sm:grid-cols-2">
          <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3">
            <div className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
              Operating relationship
            </div>
            <div className="mt-2 font-semibold text-slate-900">
              {occupancyLabel(occupancyMode)}
            </div>
          </div>
          <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3">
            <div className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
              Client ownership
            </div>
            <div className="mt-2 font-semibold text-slate-900">
              {clientOwnershipLabel(clientOwnershipMode)}
            </div>
          </div>
          <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3">
            <div className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
              Agreement version
            </div>
            <div className="mt-2 font-semibold text-slate-900">
              {agreementVersion || "Not configured"}
            </div>
          </div>
          <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3">
            <div className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
              Warning state
            </div>
            <div className="mt-2 font-semibold text-slate-900">
              {warningCount} warning{warningCount === 1 ? "" : "s"}
            </div>
          </div>
        </div>
        <div className="grid gap-3 sm:grid-cols-3">
          <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3">
            <div className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
              Deposit
            </div>
            <div className="mt-2 font-semibold text-slate-900">
              {depositAmount === null ? "--" : formatWorkspaceMoney(depositAmount, currency)}
            </div>
          </div>
          <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3">
            <div className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
              Due now
            </div>
            <div className="mt-2 font-semibold text-slate-900">
              {dueNowAmount === null ? "--" : formatWorkspaceMoney(dueNowAmount, currency)}
            </div>
          </div>
          <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3">
            <div className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
              Due later
            </div>
            <div className="mt-2 font-semibold text-slate-900">
              {dueLaterAmount === null ? "--" : formatWorkspaceMoney(dueLaterAmount, currency)}
            </div>
          </div>
        </div>
        {acceptedAt || rentalId ? (
          <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4 text-sm text-slate-600">
            {acceptedAt ? (
              <div>
                <span className="font-semibold text-slate-900">Accepted:</span> {acceptedAt}
              </div>
            ) : null}
            {rentalId ? (
              <div className={acceptedAt ? "mt-1" : ""}>
                <span className="font-semibold text-slate-900">Canonical rental:</span> #{rentalId}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    </article>
  );
}
